import { render, staticRenderFns } from "./Robot.vue?vue&type=template&id=17ea9eba&scoped=true&"
import script from "./Robot.vue?vue&type=script&lang=js&"
export * from "./Robot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ea9eba",
  null
  
)

export default component.exports